// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function name(t) {
  return t.name;
}

function value(t) {
  return t.value;
}

function setName(t, x) {
  return {
          name: x,
          value: t.value
        };
}

function setValue(t, x) {
  return {
          name: t.name,
          value: x
        };
}

function decode(json) {
  return {
          name: Json_decode.field("name", Json_decode.string, json),
          value: Json_decode.field("value", Json_decode.$$int, json)
        };
}

function encode(t) {
  return t.value;
}

exports.name = name;
exports.value = value;
exports.setName = setName;
exports.setValue = setValue;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
